import $ from 'cash-dom'
import { setSortOption } from '../pages/collection'

const sortMenu = $('[data-component="sort-menu"]')
const sortPanel = $('[data-action="toggle-sort-panel"]')

const showSortMenu = () => {
  sortMenu.attr('aria-visible', 'true')
  sortPanel.attr('aria-expanded', 'true')
}

const hideSortMenu = () => {
  sortMenu.attr('aria-visible', 'false')
  sortPanel.attr('aria-expanded', 'false')
}

$('[data-action="sort-collection"').on('click', (e) => {
  e.preventDefault()

  const sortBy = e.target.getAttribute('data-sort-by')
  const sortDisplayName = e.target.textContent.trim()

  const currentSortNameElement = $('[data-element="current-sort-name"]')
  if (currentSortNameElement.length) {
    currentSortNameElement.text(sortDisplayName)
  }

  setSortOption(sortBy)
  hideSortMenu()
})

$(sortPanel).on('click', (e) => {
  e.preventDefault()

  if ($(sortPanel).attr('aria-expanded') === 'false') {
    showSortMenu()
    return
  }
  hideSortMenu()
})

export { hideSortMenu }
